var f = {}

f.language = function(){

    var language;
    if (window.navigator.languages) {
        language = window.navigator.languages[0];
    } else {
        language = window.navigator.userLanguage || window.navigator.language;
    }

    return language
}

f.deep = function(obj, key){
    var  _key = key.split(".");

    var tkey = _key[0];

    if(typeof obj == 'undefined' || !obj) return undefined;

    if(typeof obj[tkey] != 'undefined')
    {
        _key.splice(0, 1);

        if(_key.length == 0)
        {
            return obj[tkey];
        }
        else
        {
            return f.deep(obj[tkey], _key.join("."))
        }
    }
    else
    {
        return undefined;
    }
}

var renderFrameEqualizer = function(canvas, ctx, analyser, stop, colornumbers, offset){

    

    if(!colornumbers){
        colornumbers = {
            r : 25,
            g : 250,
            b : 50
        }
    }

    if(!offset){
        offset = {
            x : 25,
            offset : [0, 0]
        }
    }

    var WIDTH = canvas.width;
    var HEIGHT = canvas.height;

    var bufferLength = analyser.frequencyBinCount;
    var dataArray = new Uint8Array(bufferLength);

    var barWidth = (WIDTH / bufferLength) / 2.5;
    var barHeight;
    
    var x = offset.x // offset[0] -15;

    analyser.getByteFrequencyData(dataArray);

    ctx.clearRect(0, 0, WIDTH, HEIGHT);

    for (var i = 0; i < bufferLength; i++) {

        barHeight = dataArray[i];
        
        var r = barHeight + (colornumbers.r * (i / bufferLength));
        var g = colornumbers.g * (i / bufferLength);
        var b = colornumbers.b;

        var opacity = - Math.abs(i - bufferLength / 2) / bufferLength + 1 / 2


        if(i > offset.offset[0] && i < bufferLength - offset.offset[1]){
            ctx.fillStyle = "rgba(" + r + "," + g + "," + b + "," + opacity * 2 + ")";
            ctx.fillRect(x, HEIGHT / 2 - (barHeight * opacity), barWidth,  barHeight * opacity * 2 );
        }
       

        x += barWidth + 1;
    }

    requestAnimationFrame(function(){
        if (stop()){

            ctx.clearRect(0, 0, WIDTH, HEIGHT);

            return
        }

        renderFrameEqualizer(canvas, ctx, analyser, stop, colornumbers, offset)
    });

}

var rand = function(min, max){
    min = parseInt(min);
    max = parseInt(max);
    return Math.floor( Math.random() * (max - min + 1) ) + min;
}

var makeid = function(valid){

    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
    }

    if(!valid)
    {
        return  s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
    }

    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for( var i=0; i < 16; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

var flball = function(str){

    //return flbb(str)

    if(!str || !str.split) return str

    var exception = ["2ndEdison, 3dCarbon", "A-Pmcs"];
    var lower = ["TO", "K", "X", "10X", "THE", "AN", "AND", "OR", "AT", "BUT", "BY", "FOR", "IN", "OF", "OFF", "ON", "OUT", "PER", "UP", "VIA", "AS", "FOR"];
    var upper = ["2MCBL",  "USA", "TONS", "BHCC", "LLC", "LTD", "1BWK", "AGMA", "VIII", "XIII", "BHCC"];
    var capital = ["LAS", "LAW","SON", "DEE", "ST", "PET", "BIG", "WAY", "AIR", "ALL", "TOP", "JOY", "CO", "INC", "INC.", "AVE", "PAY", "ST.", "FOX", "CAR", "TAX", "DAY", "MAN", "CO.", "NEW"];
    var capitalReg = new RegExp(capital.join('|'));
    var upperReg = new RegExp(upper.join('|'));


    var nameArr = str.split(' ').map(function(word){
        if (exception.some(function(w){return w.toUpperCase()===word})){

            return exception.find(function(w) {return w.toUpperCase()===word});
        }

        if (
            lower.some( function(w){
                if(w===word){
                    return true;
                };
                var wArr = w.split(' ');
                for (var i = 0; i <wArr.length; i++){
                    if(/[0-9]/.test(wArr[i]) && /ST|ND|RD|TH|K/.test(wArr[i+1] + wArr[i+2])){
                        return true;
                    }
                }
                return false;
            })
            ) 
        {
            return word.toLowerCase();
        }

        if (capitalReg.test(word)){
            return word[0]+word.slice(1).toLowerCase();
        }
        if(word.replace(/\(|\)/g, '').length<=3 || upperReg.test(word)){
            return word;
        }
        var wordCap = word.toLowerCase().replace(/[A-Za-z]/, function(l){return l.toUpperCase()});
        var wordArr = [];
        wordArr.push(wordCap[0]);
        for (var i = 0; i < wordCap.length; i++){
            if (wordCap[i+1] && (/\.|\/|[0-9]|\&|\-|\s/.test(wordCap[i]) || (wordCap[i-1]+wordCap[i]).toLowerCase() === 'mc')){
                wordArr.push(wordCap[i+1].toUpperCase());
            } else if (wordCap[i+1]){
                wordArr.push(wordCap[i+1])
            }
        };
        return wordArr.join('')
    })

    return flb(nameArr.join(' '))
}

var flb = function (str) {
    return str[0].toUpperCase() + str.substr(1);
}

var flbs = function (str) {

    if(str.length <= 1) return str

    return str[0].toUpperCase() + str.substr(1).toLowerCase();
}

var flbb = function (str) {

    var s = str.split(' ');

    return _.map(s, function(s){
        return flbs(s);
    }).join(' ')

}

f.ungroup = function(gr){
    var ungroup = [];


    _.each(gr, function(i){

        ungroup = ungroup.concat(i)

        console.log(i)

    })

    return ungroup;
}
f.group = function(array, _function){
    var group = {};

    _.each(array, function(el, i){

        var index = _function(el, i);

        if(typeof index == 'undefined') return;

        if(!group[index])
            group[index] = [];

        group[index].push(el);

    })

    return group;
}

var _scrollTop = function(scrollTop, el, time){

    if(!el) el = $("body,html");

    if(!time) time = 200;

    el.animate({ scrollTop: scrollTop }, time);
}

var _scrollTo = function(to, el, time){
    
    if(!to) to = $(this);

    var ofssetObj = to.offset();

    var offset = (to.height() - $(window).height()) / 2;

    if(ofssetObj)
    {
        var scrollTop = ofssetObj.top + offset;

        _scrollTop(scrollTop, el, time);
    }

}

var _scrollToTop = function(to, el, time, offset){
    
    if(!to) to = $(this);

    if(!offset) offset = 0;

    var ofssetObj = to.offset();

    if (ofssetObj)
    {
        var scrollTop = ofssetObj.top + offset;

        _scrollTop(scrollTop, el, time);
    }

}

var _scrollToTopP = function(to, el, time, offset){
    
    if(!to) to = $(this);

    if(!offset) offset = 0;

    var ofssetObj = to.position();

    if (ofssetObj)
    {
        var scrollTop = ofssetObj.top + offset;

        _scrollTop(scrollTop, el, time);
    }

}

var stringEq = function(s1, s2){

	if(!s1) s1 = ''
	if(!s2) s2 = ''

	var bw = function(s){
		return s.split(/[ \t\v\r\n\f,.]+/)
	}

	var hash = function(s){

		var ps = bw(s).join(' ')

		return ps.toLowerCase().replace(/[^a-zа-я0-9&]*/g, '');
	}

	

	var makeTr = function(w){
		var trs = {};

		var takeC = function(index){
			var c;

			if(index < 0 || index >= w.length) c = "_";

			else c = w[index];

			return c;
		}

		for(var i = -1; i <= w.length; i++){

			var tr = "";

			for(var j = i - 1; j <= i + 1; j++){
				tr = tr + takeC(j);
			}


			trs[tr] = 1;
		}

		return trs;
	}


	var t1 = makeTr(hash(s1)),
        t2 = makeTr(hash(s2));
        

	var c = 0,
		m = Math.max(_.toArray(t1).length, _.toArray(t2).length)

	_.each(t1, function(t, index){

		if(t2[index]) c++;

	})

	return c / m;


}

var retry = function(_function, clbk, time, totaltime){
    if(!time) time = 20;

    var totalTimeCounter = 0 

    var interval = setInterval(function(){


        if(_function() || (totaltime && totaltime <= totalTimeCounter)){

            clearInterval(interval);

            if(clbk) clbk();

        }

        totalTimeCounter += time

    }, time);
}
var pretry = function(_function, time, totaltime){
    return new Promise((resolve, reject) => {

        retry(_function, resolve, time, totaltime)

    })
}
var retryLazy = function(_function, clbk, time){
    if(!time) time = 200;

    var f = function(){
        _function(function(result){

            if(result){

                if(clbk) clbk();

            }

            else

            {
                setTimeout(f, time)
            }

        })
    }

    f();
}

var isAndroid = function(){
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1;
    
    if (isAndroid) {
        return true
    }
}

var isMobile = function(){
    return $('html').hasClass('mobile');
}

var isTablet = function(){
    return $('html').hasClass('mobile') || $('html').hasClass('tablet');
}

var slowMade = function(_function, timer, time){

    if (!time) time = 20

    if (timer)
        clearTimeout(timer);

        timer = setTimeout(_function, time);

    return timer;
}

var rand = function(min, max){
    min = parseInt(min);
    max = parseInt(max);
    return Math.floor( Math.random() * (max - min + 1) ) + min;
  }

var trim = function(s){
    return rtrim(ltrim(s));
}

var ltrim = function(s)
  {
    return (s || "").replace(/^\s+/, ''); 
  }

var rtrim = function(s){
    return (s || "").replace(/\s+$/, ''); 
}

var ltrimrn = function(s){
    return (s || "").replace(/^[\r\n\t ]+/, ''); 
}

var rtrimrn = function(s){
    return (s || "").replace(/[\r\n\t ]+$/, ''); 
}

var trimrn = function(s){
    return rtrimrn(ltrimrn(s));
}

var hexEncode= function(text){
    var ch = 0;
    var result = "";
    for (var i = 0; i < text.length; i++)
    {
        ch = text.charCodeAt(i);
        if (ch > 0xFF) ch -= 0x350;
        ch = ch.toString(16);
        while (ch.length < 2) ch = "0" + ch;
        result += ch;
    }
    return result;
}
var hexDecode= function(hex){
    var ch = 0;
    var result = "";
    hex = trim(hex);
    for (var i = 2; i <= hex.length; i += 2)
    {
        ch = parseInt(hex.substring(i - 2, i), 16);
        if (ch >= 128) ch += 0x350;
        ch = String.fromCharCode("0x" + ch.toString(16));
        result += ch;
    }
    return result;
} 

var isios = function () {
    return window.cordova && window.device && f.deep(window, 'device.platform') == 'iOS'
}

var phonenumber = function(v){

    if(!v) return v

    var x = v.replace(/\D/g, '').match(/(\d{1})(\d{0,3})(\d{0,3})(\d{0,4})/);
        v = !x[2] ? x[1] : '+' + x[1] + ' (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');

    return v
}

var wkit = {
    username : function(userinfo){

        if(!userinfo) return ''

        return _.filter([userinfo?.firstname, userinfo?.lastname], function(g){
            return g
        }).join(' ') || userinfo.email || (userinfo.phone ? phonenumber(userinfo.phone) : '') || "Wellai User"
    },

    doctorinfo : function(userinfo){

        return _.filter([userinfo?.degreeName, userinfo?.specialityName], function(g){
            return g
        }).join(', ') || ""
    }
}

f.b64toBlob = function(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

f.b64Save = function(folderpath, filename, content){

    var block = content.split(";");
    // Get the content type
    var dataType = content[0].split(":")[1];// In this case "audio/mpeg"
    // get the real base64 content of the file
    var realData = content[1].split(",")[1];// In this case "SUQzAwAAAAAD...."


    var DataBlob = f.b64toBlob(realData, dataType);

    window.resolveLocalFileSystemURL(folderpath, function(dir) {

        dir.getFile(filename, {create:true}, function(file) {

            file.createWriter(function(fileWriter) {

                fileWriter.write(DataBlob);

            }, function(){
                
            });
        });
    });
}

f.loadMessages = function(){
    const context = require.context("../locales", true, /[a-z0-9-_]+\.json$/i);

    const messages = context
        .keys()
        .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
        .reduce(
        (messages, { key, locale }) => ({
            ...messages,
            [locale]: context(key),
        }),
        {}
        );

    return {context, messages};
}


var _scrollTop = function(scrollTop, el, time){

    if(!el) el = $("body,html");

    if(!time) time = 200;

    el.animate({ scrollTop: scrollTop }, time);
}

var _scrollTo = function(to, el, time){
    
    if(!to) to = $(this);

    var ofssetObj = to.offset();

    var offset = (to.height() - $(window).height()) / 2;

    if(ofssetObj)
    {
        var scrollTop = ofssetObj.top + offset;

        _scrollTop(scrollTop, el, time);
    }

}

var _scrollToTop = function(to, el, time, offset){
    
    if(!to) to = $(this);

    if(!offset) offset = 0;

    var ofssetObj = to.offset();

    if (ofssetObj)
    {
        var scrollTop = ofssetObj.top + offset;

        _scrollTop(scrollTop, el, time);
    }

}

var _scrollToTopP = function(to, el, time, offset){
    
    if(!to) to = $(this);

    if(!offset) offset = 0;

    var ofssetObj = to.position();

    if (ofssetObj)
    {
        var scrollTop = ofssetObj.top + offset;

        _scrollTop(scrollTop, el, time);
    }

}


f.pretry = pretry
f.isios = isios
f.wkit = wkit
f.trim = trim
f.isAndroid = isAndroid
f.isMobile = isMobile
f.isTablet = isTablet
f.rand = rand
f.flball = flball
f.flb = flb
f.flbs = flbs
f.flbb = flbb
f.makeid = makeid
f.scrollTo = _scrollTo
f.stringEq = stringEq
f.retry = retry
f.retryLazy = retryLazy
f.slowMade = slowMade
f.renderFrameEqualizer = renderFrameEqualizer
f.hexEncode = hexEncode
f.hexDecode = hexDecode
f.phonenumber = phonenumber
f.scrollTo = _scrollTo

export default f